import React from "react";
import "./Usp.css";

interface UspProps {
  label: string;
  title: string;
  description: string;
  imageSrcMobile: string;
  imageSrcDesktop: string;
  mobileBgColor: string;
  alignment?: "left" | "right";
}

const baseSubheadingTitle = "label-regular mb-2";

const Usp: React.FC<UspProps> = ({
  label,
  title,
  description,
  imageSrcMobile,
  imageSrcDesktop,
  mobileBgColor,
  alignment = "left",
}) => {
  const resultTitleClass =
    alignment === "right"
      ? baseSubheadingTitle
      : `${baseSubheadingTitle} purple`;
  return (
    <div>
      <div
        className="usp-container display-desktop"
        style={{
          backgroundImage: `url(${imageSrcDesktop})`,
        }}
      >
        <div
          className="usp-content"
          style={{
            marginRight: alignment === "right" ? "3%" : "57%",
            marginLeft: alignment === "right" ? "59%" : "5%",
          }}
        >
          <p className={resultTitleClass}>{label}</p>
          <h1 className="mb-3 usp-heading">{title}</h1>
          <p className="usp-description">{description}</p>
        </div>
      </div>
      <div
        className="usp-container display-mobile"
        style={{ backgroundColor: mobileBgColor }}
      >
        <div className="usp-content">
          <p className={resultTitleClass}>{label}</p>
          <h1 className="mb-3">{title}</h1>
          <p>{description}</p>
        </div>
        <div className="mobile-image-wrapper">
          <img alt="Feature" src={imageSrcMobile} className="rounded-3xl" />
        </div>
      </div>
    </div>
  );
};
export default Usp;
